import React, { Component } from 'react';
import "./AppSuite.scss"

import { withRouter } from "react-router-dom";

class AppSuite extends Component {
    render() {
        return (
            <>
                <div className='app_suite'>
                    <div className='container'>
                        <div className='row justify-content-center pt-5'>
                            <h2 className='text_3'>Our APP Suite</h2>
                        </div>
                        <div className='row justify-content-center pt-2'>
                            <h3 className='text_4'>For IFAs & RIAs</h3>
                        </div>
                        <div className='row mt-5 pb-5'>
                            {/* <div className='col-md-6'>
                                <img className='img_1'src='../../images/4942221.png' alt='PPFAS Asset Management Pvt. Ltd'></img>
                            </div> */}
                            {/* <div className='col-md-6 m-auto'>
                                <h4 className='header_5' >RISK PROFILING <br /> Available as APP & API</h4>
                                <p className='pt-3 para_5'>MatRisQ is perhaps the only risk profiling tool in the world,hat will help you understand
                                 your client's Risk Tolerance and Capacity, distinctively.Underpinned by empirical and behavioral research.<br/>
                                 <br></br>
                                  MatRisQ is designed to explore the unexplored aspects of your client. What comes out is an insightful 
                                  report that cements your engagement plan.</p>
                                  <a className='pt2 exp_btn' target="_blank" rel="noopener noreferrer"  href='https://matrisq.pulselabs.co.in'><b>Experience MatRisQ <i class="fa fa-arrow-right"></i></b></a>
                            </div> */}
                            {/* <div className='col-md-6 m-auto mid_device'>
                                <h4 className='header_5' >GOAL PLANNING <br /> Available as APP & API</h4>
                                <p className='pt-3 para_5'>GoalPost is built with just 1 objective in mind. Never let the Advisor feel incomplete
                                    with a feature or a scenario that they want to simulate while planning for the client's goals.<br />
                                    <br></br>
                                    Imagine you are having a conversation with your client over a coffee. By the time your client is half the cup,
                                    you would be presenting a Comprehensive Retirement Report. GoalPost is the perfect blend of `Being Easy & Effective'</p>
                                    <a className='pt2 exp_btn' target="_blank" rel="noopener noreferrer" href='https://goalpost.pulselabs.co.in/'><b>Experience GoalPost <i class="fa fa-arrow-right"></i></b></a>
                            </div> */}
                            {/* <div className='col-md-6 mid_device'>
                                <img className='img_1' src='../images/4901358.png' alt='Quant Money Managers Limited'></img>
                            </div> */}
                            {/* <div className='col-md-6 small_device'>
                                <img className='img_1' src='../images/4901358.png' alt='Quantum Asset Management Company Private Limited'></img>
                            </div>
                            <div className='col-md-6 m-auto small_device'>
                                <h4 className='header_5' >GOAL PLANNING <br /> Available as APP & API</h4>
                                <p className='pt-3 para_5'>GoalPost is built with just 1 objective in mind. Never let the Advisor feel incomplete
                                    with a feature or a scenario that they want to simulate while planning for the client's goals.<br />
                                    <br></br>
                                    Imagine you are having a conversation with your client over a coffee. By the time your client is half the cup,
                                    you would be presenting a Comprehensive Retirement Report. GoalPost is the perfect blend of `Being Easy & Effective'</p>
                                    <a className='pt2 exp_btn'target="_blank" rel="noopener noreferrer" href='https://goalpost.pulselabs.co.in/'><b>Experience GoalPost <i class="fa fa-arrow-right"></i></b></a>
                            </div> */}
                            <div className='col-md-6 '>
                                <img className='img_1' src='../images/4901355.png' alt='Samco Asset Management Private Limited'></img>
                            </div>
                            <div className='col-md-6 m-auto'>
                                <h4 className='header_5'>FULLSTACK</h4>
                                <p className='pt-3 para_5'>There’s a reason why we have named our full stack platform as Alchemy.
                                    It magically transforms your practice into the digital delight that you & your clients yearned for.<br />
                                    <br></br>
                                    On-Board, Advise, Execute, Track, Review, Re-Balance. All things Automated! With Alchemy,
                                    your clients can never think of another Robo Platform or a Private Banker.</p>
                                    <a className='pt2 exp_btn' target="_blank" rel="noopener noreferrer" href='https://finapp.ai/'><b>Experience Alchemy <i class="fa fa-arrow-right"></i></b></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


export default withRouter(AppSuite)